import { Divider, Grid, styled } from "@mui/material";
import React, { memo } from "react";

import MxTypography from "@rf-l1/MxTypography";
import MxIcons from "@rf-l1/MxIcons";
import useFieldTable from "../../hooks/useBuiltTableField";

const BuildingFormTableSubHeader = () => {
  const fields = useFieldTable();
  return (
    <ContentIcons count={fields.length}>
      {fields.map(x => (
        <Grid container key={x.label} item xs="auto">
          <Divider orientation="vertical" flexItem />
          <Grid
            container
            flex={1}
            py={1}
            px={0.5}
            columnGap={1}
            alignItems="center"
            wrap="nowrap"
          >
            <Grid item xs="auto">
              <MxIcons color="primary">{x.icon}</MxIcons>
            </Grid>
            <Grid item xs="auto">
              <MxTypography
                variant="caption"
                color="primary.main"
                fontWeight={600}
                lines={1}
              >
                {x.label}
              </MxTypography>
            </Grid>
          </Grid>
        </Grid>
      ))}
    </ContentIcons>
  );
};

export default memo(BuildingFormTableSubHeader);

const ContentIcons = styled(Grid)<{ count: number }>(({ theme, count }) => () => {
  const s = {
    width: "100%",
    backgroundColor: theme.palette.grey[100],
    display: "grid",
    borderBottom: `1px solid ${theme.palette.grey[300]}`
  };

  if (count == 12) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }
  if (count == 11) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }

  if (count == 8) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 0.8fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }
  if (count == 6) {
    Object.assign(s, {
      gridTemplateColumns: `0.25fr 1fr 0.8fr 0.8fr 1.5fr 0.25fr`
    });
  }

  return s;
});
